export function resolveThemeColor(variableName: string, fallback: string, node: HTMLElement | null = null): string {
  const sources = [
    node,
    typeof document !== "undefined" ? document.documentElement : null,
    typeof document !== "undefined" ? document.body : null,
  ];

  for (const source of sources) {
    if (!source) continue;
    const value = getComputedStyle(source).getPropertyValue(variableName).trim();
    if (value) return value;
  }
  return fallback;
}

export function getChartSeriesColors(count: number, node: HTMLElement | null = null): string[] {
  const colors: string[] = [];
  for (let i = 1; i <= count; i++) {
    // Loop back to 1 if we need more than 6 colors
    const seriesIndex = ((i - 1) % 6) + 1;
    colors.push(resolveThemeColor(`--chart-series-${seriesIndex}`, "#f59e0b", node));
  }
  return colors;
}

export const SEVERITY_VARS = {
  info: "var(--severity-info)",
  warning: "var(--severity-warning)",
  critical: "var(--severity-critical)",
};
